const noError = { 
    error: false,
    errorMsg: '', 
};

const apiKeyError = {
  error: true,
  errorMsg: 'La Api Key ingresada no es válida.',
};
const videoCodeError = {
  error: true,
  errorMsg: 'El código del video de Youtube ingresado no es válido.',
};

const nameEmptyError = {
  error: true,
  errorMsg: 'El nombre es obligatorio y no puede quedar vacío.',
};

export const extractYoutubeVideoId = (input) => {
  if (!input || typeof input !== 'string') return '';
  const trimmed = input.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
    return trimmed;
  }
  const match = trimmed.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
  if (match && match[1]) {
    return match[1];
  }
  return trimmed;
};

export const fetchYoutubeVideoTitle = async (input) => {
  const videoId = extractYoutubeVideoId(input);
  if (!videoId || videoId.length !== 11) return null;

  try {
    const res = await fetch(`/api/youtube/title?videoId=${videoId}`);
    if (res.ok) {
      const data = await res.json();
      if (data?.title) return data.title;
    }
  } catch (err) {
    console.warn('Error al consultar título en backend:', err);
  }

  return null;
};

const checkYoutubeVideoCode = (videoCode) => {
    if (!videoCode) return noError;
    const extracted = extractYoutubeVideoId(videoCode);
    if(!(/^[a-zA-Z0-9_-]{11}$/.test(extracted))) return videoCodeError;
    return noError;
};

const checkYoutubeApiKey = (apiKey) => {
    if (!apiKey) return noError;
    if(!(/^[a-zA-Z0-9_-]{39}$/.test(apiKey))) return apiKeyError;
    return noError;
};

const checkApiKeysErrors = (apikeys) => {
  let errors = [];
  apikeys.forEach((value, index) => {
    errors['apikey_'+index] = checkYoutubeApiKey(value)
  });  
  return errors;
};

const nameTooLongError = {
    error: true,
    errorMsg: 'El nombre no puede superar los 50 caracteres.'
};

const checkIntrosErrors = (intros) => {
    let errors = [];
    intros.forEach((item, index) => {
      const id = typeof item === 'object' ? item.id : item;
      const name = typeof item === 'object' ? item.name : '';
      
      const codeCheck = checkYoutubeVideoCode(id);
      if (codeCheck.error) {
        errors['intro_'+index] = codeCheck;
      } else if (id && typeof item === 'object' && (!name || !name.trim())) {
        errors['intro_'+index] = nameEmptyError;
      } else if (name && name.trim().length > 50) {
        errors['intro_'+index] = nameTooLongError;
      } else {
        errors['intro_'+index] = noError;
      }
    });  
    return errors;
};

const checkTransitionsErrors = (transitions) => {
    let errors = [];
    transitions.forEach((item, index) => {
      const id = typeof item === 'object' ? item.id : item;
      const name = typeof item === 'object' ? item.name : '';

      const codeCheck = checkYoutubeVideoCode(id);
      if (codeCheck.error) {
        errors['transition_'+index] = codeCheck;
      } else if (id && typeof item === 'object' && (!name || !name.trim())) {
        errors['transition_'+index] = nameEmptyError;
      } else if (name && name.trim().length > 50) {
        errors['transition_'+index] = nameTooLongError;
      } else {
        errors['transition_'+index] = noError;
      }
    });  
    return errors;
};

const validations = {
  extractYoutubeVideoId,
  fetchYoutubeVideoTitle,
  checkYoutubeVideoCode,
  checkApiKeysErrors,
  checkIntrosErrors,
  checkTransitionsErrors
}
export default validations;

